import React, {useState, useEffect} from "react";
import Wrp from "../../hoc/Wrp/Wrp";
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import {parameterizedURLAccessToken,getPdfPreferenceByWindowId} from '../../Utils/CommonFunctions';
import {getUserInfo,setUserInfoSession} from '../../Utils/UserFunctions';
import { callPOST } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';
import ToolTipWrapper from '../../hoc/Wrp/ToolTipWrapper';

const HtmlPdfPReview = (props) => {

	const [content, setContent] = useState('');
	const [iterateData, setIterateData] = useState({});

	const checkColumns = (e) => {
		const {name,value,checked} = e.target;
		const windowId = props.match.params.windowId;
		const list = {...iterateData}

		if(checked === true) {
			if(list[windowId]) {
				list[windowId].push(value);
			}else {
				list[windowId] = [];
				list[windowId].push(value);	
			}
		}else {
			const windIndex = list[windowId].indexOf(value);
			if(windIndex !== -1)
				list[windowId].splice(windIndex, 1);
		}
		setIterateData(list);
	}

	const replaceImg = (cont) => {
		// const imgRex = /<img.*?[src=][src =]"(.*?)"[^>]+>/g;
		const imgRex = /<img.*?src ="(.*?)"[^>]+>/g;
		const imgRex1 = /<img.*?src="(.*?)"[^>]+>/g;
	  	let images = [];
	    let img;
	    while ((img = imgRex.exec(cont))) {
	     	images.push(img[1]);
	    }
	    while ((img = imgRex1.exec(cont))) {
	     	images.push(img[1]);
	    }
			images = [...new Set(images)];
	    images.map((arr,i) => {
	    	if(arr !== '') {
	    		const imagePath = parameterizedURLAccessToken('files/download?fileId='+arr);
		    	// const replaceString =  arr+'/g';
		    	try {
		    		const regex = new RegExp(arr, "g");
		    		cont = cont.replace(regex,imagePath);
		    	}catch {
		    		cont = cont;
		    	}
		    	
	    	}
	    })
	    return cont;
	}

	const selectedTemplateContent = (id) => {
		let cont = '';
		props.selectTemplate(id);
	    // props.pdfCreationList ?
	      props.pdfCreationList.map((arr,i) => {
	        if(id === arr.id) {
	        	cont = arr.html_content;
			    	setContent(cont);
	        }
	      })
	    // : null
	    return cont;
	}

	const selectedTemplateContent1 = (id) => {
		let cont = '';
		props.selectTemplate(id);
	    // props.pdfCreationList ?
	      cont = props.pdfCreationList[id];
	      setContent(cont);
    	  // cont = arr.html_content;
	    // : null
	    return cont;
	}

	useEffect( () => {
		callInitialData();
	}, [props.selectedId]);

	const callInitialData = () =>{
		const windowId = props.match.params.windowId;
		if(props.previewScreen !== 'new' && props.previewScreen !== 'viewList'){
			selectedTemplateContent(props.selectedId);
		}else if(props.previewScreen !== 'new' && props.previewScreen !== 'viewList'){
			selectedTemplateContent1(props.selectedId);
		}
		const pdfPref = getPdfPreferenceByWindowId(windowId);
		if(!iterateData[windowId]) {
			let data = {};
			data[windowId] = pdfPref;
			setIterateData(data);	
		}
		
	}

	const downloadPDF = (e,isMail=false) => {
		console.log('downloadPDF');
		const params = props.match.params;
		const val = Array.isArray(props.currentData) ? props.currentData : [props.currentData];
		const idCount = val.length;
    if(!isMail && idCount > 3) {
      props.toggleMailHandler('PDF');
      return false;
    }
    props.Loader();
		const body = {
      ids : val,
      to  : props.maxExceedMail
    }
		callPOST('data-convertor/'+params.windowId+'/htmlTopdf/'+props.selectedId,body)
	    .then(response => {
	    	props.Loader();
	        const responseData = response.data;
	        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	          let APIURL = "files/download?fileId="+responseData.data;
	          document.location.href = parameterizedURLAccessToken(APIURL);
	          props.succMessage('Downloaded Successfully');
	        }else {
	        	props.failMessage(responseData.message);
	        }
      	}, (error) => {
      		props.Loader();
      		props.failMessage('Error occured!');
        	console.log(error);
      	})
	}

	const prepareReq = () => {
		let returnVal = null;
		const windowId = props.match.params.windowId;
		const userInfo = getUserInfo();
    const info = userInfo.data.user_preference;
    if(info.pdf_preview_preferences) {
      let isUpdate = true;
      info.pdf_preview_preferences.map((arr,ind) => {
        if(arr[windowId]) {
          arr[windowId] = iterateData[windowId];
          isUpdate = false;
        }
      })
      if(isUpdate) {
      	info.pdf_preview_preferences.push(iterateData);
      }
    }else {
    	info.pdf_preview_preferences = [iterateData];
    }
    if(info.default_module && info.default_module !== '') {
    	info.default_module = info.default_module;
    }else {
    	info.default_module = 'CRM';
    }
    if(info.default_grid_view && info.default_grid_view !== '') {
    	info.default_module = info.default_module;
    }else {
    	info.default_grid_view = 'LIST';
    }
    return info;
	}

	const saveList = () => {
		props.Loader();
		const windowId = props.match.params.windowId;
		console.log(iterateData[windowId]);
		const body = prepareReq();
		callPOST('users/preference/update',body)
	    .then(response => {
	    	props.Loader();
	        const responseData = response.data;
	        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	          props.succMessage(responseData.message);
	          setUserInfoSession(responseData);
	          // callInitialData();
	          const pdfPref = getPdfPreferenceByWindowId(windowId);
						// if(!iterateData[windowId]) {
							let data = {};
							data[windowId] = pdfPref;
							setIterateData(data);	
						// }
	        }else {
	          props.failMessage(responseData.message);
	        }
      	}, (error) => {
      		props.Loader();
      		props.failMessage('Error occured!');
          	console.log(error);
      	})
	}

	const getPdfNameById = (id) => {
		let val = '';
		if(props.pdfCreationList){
			props.pdfCreationList.map((arr,i) => {
				if(id===arr.id)
					val = arr.design_name;
			})
		}
		return val;
	}

	const parentDownloadPdf = (e) => {
		props.downloadPDF(e,false,iterateData);
	}

	const params = props.match.params;
	const pdfPref = getPdfPreferenceByWindowId(props.match.params.windowId);
	const dataVal = iterateData[params.windowId];

	let isPdfExist = false;
	if(props.htmlList && props.htmlList !== '' && props.htmlList.length > 0) {
		isPdfExist = true;
	 // var arrrayBuffer = window.btoa(unescape(encodeURIComponent(props.htmlList)));
	}
	console.log(props.pdfdata)
	return (
		<Wrp>
		<div className={props.isModalOpen === true ? "custom-template eComOpen htmlPDF open" : "custom-template eComOpen htmlPDF" }>
			
			<div className="title"> PDF Preview  </div>
				
			<div className="page-with-aside mail-wrapper">
				{ props.previewScreen !== 'new' && props.previewScreen !== 'viewList' ?
				<div className="page-aside bg-grey1 p-0"> 
					<div className="aside-nav collapse">
						<label className="p-2  text-bold">
							PDF Template List
						</label>
						<ul className="nav">
						{
							props.pdfCreationList ?
								props.pdfCreationList.map((arr,i) => {
									return (
										<li className={ props.selectedId===arr.id ? "active" : "" } onClick={e=>selectedTemplateContent(arr.id)} key={i} ide={arr.id}>
											<a> {arr.design_name} </a>
										</li>
									)
								})
							: null
						}
						</ul>
					</div>
				</div>
				: props.previewScreen === 'viewList' ?
				<div className="page-aside bg-grey1 p-0"> 
					<div className="aside-nav collapse mb-5">
						<div className="d-flex align-items-center justify-content-between border-bottom">
							<label className="p-2 w-100 text-bold border-bottom text-small"> Saved List </label>
							<div className=""> <button type="button" className="btn btn-xs primary_bg mr-2" onClick={saveList}> Save </button></div>
						</div>
						
						<ul className="nav" style={{background: "#fafafa"}}>
						{
							pdfPref && pdfPref.length > 0 ?
								pdfPref.map((arr,ind) => {
									const valExist = dataVal ? dataVal.indexOf(arr) === -1 ? false : true : true;
									return(
										<li className={ props.selectedId===arr ? "active mb-0 pr-0" : "mb-0 pr-0" }>
											<div className="w-100 custom-control custom-checkbox px-2 d-flex align-items-center justify-content-between cursor-none">
												<input type="checkbox" onChange={checkColumns} className="custom-control-input" id={"default_"+ind} value={arr} checked={valExist}/>
												<label className="custom-control-label mb-0 text-small cursor-pointer" htmlFor={"default_"+ind}> {getPdfNameById(arr)} </label>
												<div className="text-small"> <a onClick={e=>props.layoutPreviewList(props.currentData,arr)} className="primary_color"> <i className="far fa-eye"></i> </a></div>
											</div>
										</li>
									)
								})
							: <li className="mb-0 pr-0"> No records found</li>
						}
						</ul>
					</div>

					<div className="aside-nav collapse mb-5">
						<div className="d-flex align-items-center justify-content-between border-bottom">
							<label className="p-2 text-bold "> Template List </label>
							{/*<div className=""> <button type="button" className="btn btn-xs primary_bg mr-2" onClick={saveList}> Save </button></div>*/}
						</div>
						<ul className="nav">
						{
							props.pdfCreationList && props.pdfCreationList.length > 0 ?
								props.pdfCreationList.map((arr,i) => {
									{/*const dataArr = iterateData[params.windowId] ? iterateData[params.windowId] : []; */}
									return (
										pdfPref.indexOf(arr.id) === -1 ? 
										<li className={ props.selectedId===arr.id ? "active mb-0 pr-0" : "mb-0 pr-0" }>
											<div className="w-100 custom-control custom-checkbox px-2 d-flex align-items-center justify-content-between cursor-none">
												<input onChange={checkColumns} type="checkbox" className="custom-control-input" id={"list_"+i} value={arr.id} />
												<label className="custom-control-label mb-0 text-small cursor-pointer" htmlFor={"list_"+i}> {arr.design_name} </label>
												<div className="text-small"> <a onClick={e=>props.layoutPreviewList(props.currentData,arr.id)} className="primary_color cursor-pointer" title="Preview"> <i className="far fa-eye"></i> </a></div>
											</div>
										</li>
										: null
									)
								})
							: <li className="mb-0 pr-0"> No records found</li>
						}
						</ul>
					</div>
				</div>
				: props.previewScreen === 'viewList1' ?
				<div className="page-aside bg-grey1 p-0"> 
					<div className="aside-nav collapse">
						<label className="p-2  text-bold">
							<span className="badge badge-info"> {params.windowName} </span> PDF Template  List
						</label>
						<ul className="nav">
						{
							props.pdfCreationList ?
							<Wrp>
							{
								 Object.entries(props.pdfCreationList).map(([k,value],i) => 
								 	<li className={ props.selectedId===k ? "active" : "" } onClick={e=>selectedTemplateContent1(k)} ide={k}>
											<a> {k} </a>
									</li>)  

							}
							</Wrp>
							: null
						}
						</ul>
					</div>
				</div>
				: null }
				<div className=" w-100 pr-1 position-relative">
				{
					props.currentData ?
						Array.isArray(props.currentData) ? 
						props.currentData.length > 2 ?
							<div className="alert badge-warning fade show">
					    	<strong>Warning!</strong> This is sample preview page, this contains less number of records. For selected templates having filters, the PDF generates only if the filter condition is applied.
							</div>
						: null
						: null
					: null
				}
					{ props.previewScreen !== 'new' && props.previewScreen !=='viewList' ? 
						<Link to={"/pdf-template/"+props.selectedId }>
							<span className="shadow badge-warning cursor-pointer htmlPdfEdit"> <i className="fas fa-pencil-alt"></i> </span>
						</Link>
					: null }

					{ props.previewScreen ==='viewList' ? 
						<a onClick={parentDownloadPdf}>
							<span data-tip="Download Pdf" className="shadow badge-warning cursor-pointer htmlPdfEdit"> <i className="fas fa-download"></i> </span>
						</a>
					: null }
					<div>
						{ 
							props.previewScreen === 'new' ?
								<iframe src={"data:text/html,"+encodeURIComponent( replaceImg(props.pdfdata.htmlContent) )} className="w-100"/>
							: props.previewScreen === 'viewList' ?
								isPdfExist === true ?
								<iframe src={"data:application/pdf;base64,"+props.htmlList+"#toolbar=0"} className="w-100"/>
								: <span>No Preview</span>
							: 
								<iframe src={"data:text/html,"+encodeURIComponent( replaceImg(content) )} className="w-100"/>
						}
					</div>
			</div>


			<div className="close-popup" onClick={e=>props.toggleHandler()}>
				<i className="fas fa-times"></i>
			</div>

		</div> 
		<ToolTipWrapper />
		</div>
		</Wrp>
	);
}

const mapStateToProps = state => {
  return {
    authenticated: state
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HtmlPdfPReview));